import { c as _c } from "react/compiler-runtime";
import Cell from './elements/Cell';
import type { ColumnConfig, ColumnField } from './types';
function HeaderDataCell(t0) {
  const $ = _c(7);
  const {
    label,
    width,
    minWidth,
    maxWidth,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== className || $[2] !== label || $[3] !== maxWidth || $[4] !== minWidth || $[5] !== width) {
    t1 = <Cell as="th" className={className} width={width} minWidth={minWidth} maxWidth={maxWidth}>{label}{children}</Cell>;
    $[0] = children;
    $[1] = className;
    $[2] = label;
    $[3] = maxWidth;
    $[4] = minWidth;
    $[5] = width;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}
export default HeaderDataCell;